import styled from "styled-components";

import { IStyledAttributes } from "@ryde/shared";
import { rydeColors } from "@ryde/theme";

export const ProfileFormContent = styled.div.attrs<IStyledAttributes>({
  "data-e2e": "profile-form-content",
})`
  width: 800px;
  background-color: ${rydeColors.smoke};
  label {
    margin-top: 10px;
    margin-bottom: 5px;
  }
  button {
    margin-top: 20px;
  }
`;
